import { calculateScreen, MAXIMUM_HEIGHT, MAXIMUM_WIDTH, onScreenUpdate, updateScreen, } from "common/screen";
export function letterbox(resizer) {
    updateScreen("#scene");
    updateScreen("#pixi-canvas");
    updateScreen("#video-parent");
    resizer.add(() => {
        updateScreen("#scene");
        updateScreen("#pixi-canvas");
        updateScreen("#video-parent");
    });
}
export { onScreenUpdate, MAXIMUM_HEIGHT, MAXIMUM_WIDTH, updateScreen, calculateScreen, };
//# sourceMappingURL=screen.js.map